import { createContext, useContext } from "react";
import type { AdminSession } from "@/lib/auth";

export interface AuthContextValue {
  session: AdminSession | null;
  status: "loading" | "authenticated" | "anonymous";
  signIn: () => void;
  signOut: () => Promise<void>;
  refresh: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext);
  if (!value) throw new Error("useAuth must be used inside <AuthProvider>");
  return value;
}
